import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import PopoverMenu from '@alphapoint/apex-web/lib/components/common/PopoverMenu/PopoverMenu';
import APIcon from '@alphapoint/apex-web/lib/components/common/APIcon';
import Spinner from '@alphapoint/apex-web/lib/components/common/Spinner/Spinner';
import { getBEMClasses } from '@alphapoint/apex-web/lib/helpers/cssClassesHelper';

import './AccountsDropdownComponent.css';

class AccountsDropdown extends React.Component {
  static propTypes = {
    selectedAccount: PropTypes.shape({
      AccountName: PropTypes.string.isRequired,
    }),
    accounts: PropTypes.array.isRequired,
    logout: PropTypes.func.isRequired,
    history: PropTypes.object,
    settingsRoute: PropTypes.string,
    activityRoute: PropTypes.string,
    betaOptedIn: PropTypes.string,
  };

  static defaultProps = {
    settingsRoute: '',
  };

  selectAccount = (account) => {
    this.props.selectAccount(account.AccountId, account.OMSID);
  };

  renderMenuItems = () => {
    const { t, accounts, selectedAccount } = this.props;

    if (!accounts.length || !selectedAccount) {
      return [];
    }

    let menuItems;
    if (accounts.length <= 1) {
      menuItems = [
        {
          label: selectedAccount.AccountName,
          customClass: t('username-in-dropdown'),
        },
      ];
    } else {
      menuItems = [
        ...accounts
          .filter((account) => account.AccountId !== selectedAccount.AccountId)
          .map((account) => {
            const label = account.AccountName;

            return {
              label,
              onClick: () => this.selectAccount(account),
            };
          }),
      ];
    }

    return menuItems;
  };

  render() {
    const { accounts, selectedAccount, customClass } = this.props;
    const bemClasses = getBEMClasses(['accounts-dropdown', customClass]);

    if (!accounts || accounts.length === 0) return null;

    return (
      <div className={bemClasses('container')}>
        {selectedAccount ? (
          <PopoverMenu
            customClass={bemClasses()}
            popoverProps={{
              trigger: (props) => (
                <button className={bemClasses('popover-menu-trigger')} {...props}>
                  <div className={bemClasses('accounts-info-container')}>
                    <APIcon name="account" customClass={bemClasses('icon')} />
                    <span className={bemClasses('username-in-display')}>{selectedAccount.AccountName}</span>
                    <span className={bemClasses('popover-menu-trigger-triangle')} />
                  </div>
                </button>
              ),
              customClass: 'accounts-dropdown',
            }}
            items={this.renderMenuItems()}
          />
        ) : (
          <Spinner isInline customClass={bemClasses} />
        )}
      </div>
    );
  }
}

export default withTranslation()(AccountsDropdown);
